module.exports = __webpack_public_path__ + "static/logos/logo-comscore-e7b5c78d0d5276e794eb983ffc22a4fe.png";